// Get the necessary elements
const addButton = document.querySelector(".js-add-partner");
const removeButtons = document.querySelectorAll(".js-remove-partner");
const totalPartnerId = document.getElementById(
  "id_partner_organizations-TOTAL_FORMS"
);
// Add event listener to the add button
if (addButton) {
  addButton.addEventListener("click", function () {
    addPartner(false);
  });
}

if (removeButtons.length > 0) {
  // Iterate over each element
  for (let i = 0; i < removeButtons.length; i++) {
    // Add click event listener to each element
    removeButtons[i].addEventListener("click", function (event) {
      removePartner(event.target);
    });
  }
}

// Function to handle the click event
export default function addPartner(partner, ldatId, previousLdatId) {
  const partnersDiv = document.querySelector(".partners");
  let partnerCount = parseInt(totalPartnerId.value);
  const cap = document.getElementById("current-cap-id");
  const capId = cap.value;
  // Create the new partner element
  const partnerDiv = document.createElement("div");
  let partnerName;
  let updatedString;
  let partnerInput = document.querySelector(".partner-field input");
  if (partner) {
    // if it is called from ldatSelection
    partnerName = partner.account_name.trim();

    //Remove partner that is shown from SF
    if (ldatId !== previousLdatId) {
      const partnerElements = document.querySelectorAll(".partners .current");
      partnerElements.forEach((partnerElement) => {
        const btnRemove = partnerElement.querySelector(".btn-remove");

        if (btnRemove) {
          btnRemove.click();
        }
      });
    }

    const existingPartnerElements = document.querySelectorAll(
      ".partners .js-partner"
    );

    // Check if partnerName already exists in existingPartnerElements
    const partnerNamesArray = Array.from(existingPartnerElements).map((el) =>
      el.textContent.trim()
    );

    if (partnerNamesArray.includes(partnerName)) {
      return false;
    }
    partnerDiv.classList.add("current");
  } else {
    partnerName = partnerInput.value.trim();
  }

  if (partnerName) {
    updatedString = partnerInput.name.replace(
      /\d+-(name)/,
      `${partnerCount - 1}`
    );
    partnerDiv.classList.add("chip");

    const partnerNameSpan = document.createElement("span");
    partnerNameSpan.textContent = partnerName;

    const removeButton = document.createElement("button");
    removeButton.type = "button";
    removeButton.classList.add("btn-remove");
    removeButton.setAttribute("aria-label", `remove ${partnerName}`);

    // Append the partner name and remove button to the partner div
    partnerDiv.appendChild(partnerNameSpan);
    partnerDiv.appendChild(removeButton);

    // Append the partner div to the partners container
    partnersDiv.appendChild(partnerDiv);

    // Create the hidden input field with the increased value
    const hiddenInput = document.createElement("input");
    const hiddenNameInput = document.createElement("input");
    const total = partnerInput.name.replace(/\d+-(name)/, `${partnerCount}`);
    const hiddenCapInput = document.createElement("input");
    hiddenInput.type = "hidden";
    hiddenInput.name = `${updatedString}-id`;
    hiddenInput.id = `id_${updatedString}-id`;
    hiddenNameInput.type = "hidden";
    hiddenNameInput.name = `${updatedString}-name`;
    hiddenNameInput.id = `id_${updatedString}-name`;
    hiddenNameInput.value = partnerName;
    hiddenCapInput.type = "hidden";
    hiddenCapInput.name = `${updatedString}-cap`;
    hiddenCapInput.id = `id_${updatedString}-cap`;
    hiddenCapInput.value = capId;
    partnerInput.name = capId;
    partnerInput.name = `${total}-name`;
    partnerInput.id = `id_${total}-name`;

    removeButton.addEventListener("click", function () {
      partnerDiv.remove();
      hiddenInput.remove();
      hiddenCapInput.remove();
      hiddenNameInput.remove();
      partnerCount--;
      // Update the partner field's value
      totalPartnerId.value = partnerCount;
    });

    // Append the hidden input field to the partner div
    partnerDiv.appendChild(hiddenInput);
    partnerDiv.appendChild(hiddenCapInput);
    partnerDiv.appendChild(hiddenNameInput);

    // Update the input field's value
    partnerCount++;
    totalPartnerId.value = partnerCount;
    // Clear the input field
    partnerInput.value = "";
  }
}

function removePartner(btn) {
  let partnerId = btn.getAttribute("data-partner-id"); // Get the data-partner-id attribute value
  let hiddenInput = document.querySelector(
    'input[name^="partner_organizations"][value="' + partnerId + '"]'
  ); // Find the hidden input with the partner ID value
  let hiddenInputName = hiddenInput.name;
  let hiddenInputs = document.querySelectorAll(
    'input[name^="' + hiddenInputName.replace(/id$/, "") + '"]'
  );
  let partnerCount = parseInt(totalPartnerId.value);
  btn.closest(".js-partner").remove();
  partnerCount--;
  // // Update the total partner field's value
  totalPartnerId.value = partnerCount;

  if (hiddenInputs.length > 0) {
    hiddenInputs.forEach(function (input) {
      input.remove();
    });
  }
}
